// Runs on every [data-pack-offer-section] instance of sections/featured-product.liquid
// that has a real Pack of 2 offer (pack_variant and single_variant both present -
// see the Liquid conditional around this script tag).
//
// BOTH offer radios carry the SAME value: the SINGLE variant's id. "Pack of 2"
// is a storefront pricing option only, never its own cart line/SKU - picking it
// submits the Single variant with quantity x 2, so Shopify orders, inventory
// and Aramex only ever see the Single SKU. The radios therefore differ only in
// data-pack-multiplier (1 vs 2), which this file copies onto the Add to Cart
// button; assets/quantity-selector.js multiplies the submitted quantity by it
// and window.Velo.refreshAddToCartText recomputes every displayed price
// (button total, [data-featured-price]) through the shared pricing engine, so
// this file never writes a price itself.
//
// Selecting Pack of 2 never resets the quantity - the submitted variant is
// unchanged, only the multiplier moves.
//
// Also wires the custom "Buy with Pay" CTA (not Shopify's native branded
// accelerated checkout / payment_button) to the shared
// window.Velo.checkoutSelectedVariant action (assets/checkout-selected-variant.js),
// submitting the same variant id and physical quantity as the form.
(function () {
  document.querySelectorAll('[data-pack-offer-section]').forEach(function (section) {
    var variantSelect = section.querySelector('[data-pack-offer-variant-select]');
    var radios = section.querySelectorAll('[data-pack-offer-radio]');
    var form = section.querySelector('[data-cart-form]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var applePayBtn = section.querySelector('[data-apple-pay-cta]');
    var errorContainer = section.querySelector('[data-cart-error]');

    if (!variantSelect) return;

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;

        variantSelect.value = radio.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

        if (addToCartBtn) {
          var available = radio.dataset.available !== 'false';
          addToCartBtn.disabled = !available;
          addToCartBtn.classList.toggle('opacity-50', !available);
          addToCartBtn.classList.toggle('cursor-not-allowed', !available);
          addToCartBtn.dataset.variantId = radio.value;
          addToCartBtn.dataset.price = radio.dataset.price;
          addToCartBtn.dataset.compareAtPrice = radio.dataset.compareAtPrice || 0;
          addToCartBtn.dataset.isSingleVariant = radio.dataset.isSingle;
          addToCartBtn.dataset.packMultiplier = radio.dataset.packMultiplier || 1;
        }
        window.Velo.refreshAddToCartText(form || section);
      });
    });

    if (applePayBtn) {
      applePayBtn.addEventListener('click', function () {
        if (applePayBtn.disabled) return;
        // Physical quantity (displayed x pack multiplier) - identical payload
        // to the native form submit.
        var quantity = window.Velo.getPhysicalQuantity(form || section);
        window.Velo.checkoutSelectedVariant({
          variantId: variantSelect.value,
          quantity: quantity,
          button: applePayBtn,
          errorContainer: errorContainer
        });
      });
    }
  });
})();
